import { useQuery } from "@tanstack/react-query";
import { CorrectionsData, searchCorrections } from "./actions";

export const useCorrectionSearch = ({
  search,
  limit,
  initialData
}: {
  search?: string;
  limit?: number;
  initialData?: CorrectionsData;
}) => {
  return useQuery({
    queryKey: ["corrections", { search, limit }],
    queryFn: async () => {
      const corrections = await searchCorrections({ query: search, limit });

      return corrections;
    },
    refetchOnMount: true,
    initialData: initialData
  });
};
